<template>
  <data-loader uri="/admin/api/settings">
    <page
      :title="$tc('settings')"
      size="is-desktop"
      slot-scope="{ data: settings, loading }"
      :loading="loading"
    >
      <div v-if="settings">
        <setting-group :title="$tc('tools')">
          <setting-item :title="$tc('cacheClear')">
            <cache-clear>
              <button
                class="button"
                slot="trigger"
                slot-scope="{ processing }"
                :class="{ 'is-loading': processing }"
              >
                <span>{{$tc('clear')}}</span>
              </button>
            </cache-clear>
          </setting-item>

          <setting-item title="Clear cache /home/">
            <cache-clear tags="home">
              <button
                class="button"
                slot="trigger"
                slot-scope="{ processing }"
                :class="{ 'is-loading': processing }"
              >
                <span>{{$tc('clear')}}</span>
              </button>
            </cache-clear>
          </setting-item>

          <setting-item title="XTRA subscription">
            <div slot="description">
              <p>
                Deeplink:
                <strong>mynewsstandplus://q?type=plan</strong>
              </p>
            </div>

            <setting-switch
              setting="xtra_enabled"
              :value="settings.guests_can_download_free_publications"
            ></setting-switch>
          </setting-item>
        </setting-group>

        <setting-group :title="$tc('ads.ads')">
          <setting-expandable-item title="Popup">
            <popup-configuration position="app-opening-popup"></popup-configuration>
          </setting-expandable-item>
        </setting-group>
        <setting-group :title="$tc('changeLanguage')">
          <setting-expandable-item :title="$tc('dropdown.language')">
            <div>
              <template>
                <b-select v-model="form.locale">
                  <option value="en">English</option>
                  <option value="mn">Mongolia</option>
                </b-select>
                <button @click="onClick" class="button is-primary mt-8">
                  <span>
            <slot>{{$tc('change')}}</slot>
                </span>
                </button>
              </template>
            </div>
          </setting-expandable-item>
        </setting-group>

        <setting-group title="Restricted IP">
          <setting-expandable-item title="Ips">
            <restricted-ip title="Restricted IP">
            </restricted-ip>
          </setting-expandable-item>
        </setting-group>
      </div>
    </page>
  </data-loader>
</template>

<script>
import SettingGroup from "./../../../../components/layouts/settings/SettingGroup";
import SettingItem from "./../../../../components/layouts/settings/SettingItem";
import SettingExpandableItem from "./../../../../components/layouts/settings/SettingExpandableItem";
import SettingSwitch from "./../../components/SettingSwitch";

import CacheClear from "./../../components/CacheClear";
import PopupConfiguration from "./components/PopupConfiguration";
import RestrictedIp from "./components/RestrictedIp";

export default {
  components: {
    RestrictedIp,
    CacheClear,
    PopupConfiguration,
    SettingGroup,
    SettingItem,
    SettingExpandableItem,
    SettingSwitch
  },

  data() {
    return {
      form: new window.Form({
        locale: this.$i18n.locale,
        current: this.$i18n.locale,
      })
    };
  },

  methods:{
    onClick(){
       this.form.post('api/locale');
       window.location.reload();
    }
  }
};
</script>
